import { useOutletContext } from 'react-router-dom';
import HandoverLog from '@/components/client/HandoverLog';

export default function ClientHandoverLog() {
  const { clientId } = useOutletContext();
  return (
    <div className="space-y-6" data-testid="client-handover-page">
      <div>
        <h1 className="font-heading text-2xl text-[#2C2420] mb-1">Handover Log</h1>
        <p className="text-sm text-[#5D524D]">
          Structured notes shared across service lines — discussions, pending items, and handovers so no context is lost between team members.
        </p>
      </div>
      <HandoverLog clientId={clientId} />
    </div>
  );
}
